module.exports = __webpack_public_path__ + "static/media/move-forward-tool.2468fcf3.svg";